import { render, staticRenderFns } from "./TokenLogin.vue?vue&type=template&id=2dc1d824&scoped=true&"
import script from "./TokenLogin.vue?vue&type=script&lang=js&"
export * from "./TokenLogin.vue?vue&type=script&lang=js&"
import style0 from "./TokenLogin.vue?vue&type=style&index=0&id=2dc1d824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1d824",
  null
  
)

export default component.exports